module.exports = __webpack_public_path__ + "static/media/diacc.fcf0d25d.webp";